import { UserSearch, Sparkles, Handshake } from 'lucide-react';

const steps = [
  {
    icon: UserSearch,
    number: '1',
    title: 'Define Target',
    description: 'Tell us about your ideal customer profile and target market',
    borderClass: 'landing-border-purple',
  },
  {
    icon: Sparkles,
    number: '2',
    title: 'Generate Leads',
    description: 'We automatically discover and enrich qualified leads for you',
    borderClass: 'landing-border-cyan',
  },
  {
    icon: Handshake,
    number: '3',
    title: 'Close Deals',
    description: 'Focus on selling while we keep your pipeline full',
    borderClass: 'landing-border-fuchsia',
  },
];

export const StepsSection = () => {
  return (
    <section id="how-it-works" className="py-24 px-4">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 landing-gradient-text">
            How It Works
          </h2>
          <p className="landing-text-muted max-w-xl mx-auto">
            Get started in minutes with our simple 3-step process
          </p>
        </div>

        <div className="relative">
          {/* Connecting line - hidden on mobile */}
          <div className="hidden lg:block absolute top-24 left-1/4 right-1/4 h-0.5 bg-gradient-to-r from-purple-500 via-cyan-500 to-fuchsia-500 opacity-30" />

          <div className="grid md:grid-cols-3 gap-12 lg:gap-8">
            {steps.map((step) => (
              <div key={step.number} className="text-center">
                {/* Icon Circle */}
                <div className={`w-20 h-20 mx-auto rounded-full flex items-center justify-center mb-6 bg-slate-900 ${step.borderClass}`}>
                  <step.icon className="w-8 h-8 text-white" />
                </div>

                {/* Step Number */}
                <div className="text-sm font-medium landing-text-muted mb-2">
                  Step {step.number}
                </div>

                {/* Title */}
                <h3 className="text-xl font-semibold mb-3 text-white">
                  {step.title}
                </h3>

                {/* Description */}
                <p className="landing-text-muted text-sm max-w-xs mx-auto">
                  {step.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
